module.exports = __webpack_public_path__ + "img/uz.aa7991f6.svg";